import { heroes } from "utils/heroes";

export const getRandomHeroUrl = () => {
  const randomIndex = Math.floor(Math.random() * heroes.length);
  return heroes[randomIndex];
};
